import type { DebugFlags } from '$lib/types/types';
import { create_store } from '$lib/query-store';

export const debug_flags = create_store<DebugFlags>();
